<template>
    <div id="app" :class="theme">
        <div class="main">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-9 col-xl-7">
                        <transition name="fade-in">
                        <header class="header d-flex align-items-center"  v-if="showContent">
                            <router-link :to="{name: 'documents'}">
                                <img class="logo" :src="'/build/assets/img/' + theme +'.png'" alt="">
                            </router-link>

                            <language-menu></language-menu>
                        </header>
                        </transition>
                        <transition name="fade-in">
                            <main class="panel"  v-if="showContent">
                                <router-view>

                                </router-view>
                        </main>
                        </transition>

                        <loader></loader>
                    </div>
                </div>
            </div>
        </div>
        <footer class="footer">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-md-12 col-lg-9 col-xl-7">
                        <transition name="fade-in">
                            <ul class="footer-list list list--horizontal"  v-if="showContent">
                                <li class="footer-list__item list__item list__item--horizontal list__item--line">
                                    <span class="copyright">&copy; {{ new Date().getFullYear() }} {{brand}}</span>
                                </li>
                                <li class="footer-list__item list__item list__item--horizontal list__item--line">
                                    <a :href="termsLink" target="_blank" class="footer-list__link">
                                        <T>Disclaimer</T>
                                    </a>
                                </li>
                                <li class="footer-list__item list__item list__item--horizontal list__item--line">
                                    <a :href="privacyLink" target="_blank" class="footer-list__link">
                                        <T>Privacy</T>
                                    </a>
                                </li>
                            </ul>
                        </transition>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import cssVars from 'css-vars-ponyfill';

    export default {
        name: 'app',
        data: function() {
            return {
                theme: null,
                privacyLink: null,
                termsLink: null,
                brand: null,
                showContent: false,
            }
        },
        computed: mapState(['activeLocale']),
        watch: {
            // when the activeLocale change then try to translate again
            activeLocale() {
                this.getTheme();
            },
        },
        methods: {
            getTheme() {
                let self = this;

                self.$store.commit('setLoading',true);

                self.$Api.get('theme')
                .then(function(response) {
                    if(response) {
                        self.theme = response.data.theme;
                        self.privacyLink = response.data.privacy;
                        self.termsLink = response.data.terms;
                        self.brand = response.data.brand;
                        self.$root.theme = response.data.theme;
                    }
                })
                .finally(function(){
                    self.showContent = true;
                });
            }
        },
        created: function() {
            this.getTheme();
        }
    }
</script>

<style lang="scss">
    @import "assets/scss/app";
</style>



// WEBPACK FOOTER //
// src/App.vue